module.exports = __webpack_public_path__ + "media/images/featured-products/essentials-9d0d1d8014389f5a38d0ce88ff5749bf.svg";